import { FunctionComponent, memo, useContext } from "react";
import { IProps } from "./tag-group-actions-menu.types";
import { EllipsisMenu } from "@edgetier/client-components";
import DeleteTagGroup from "./delete-tag-group";
import EditTagGroup from "./edit-tag-group";
import ExploreTagGroup from "./explore-tag-group";
import TagsListContext from "../../tags-list-context/tags-list-context";
import "./tag-group-actions-menu.scss";

/**
 * A menu to edit or delete a tag group.
 * @param props.tagGroup   The tag group name.
 * @param props.tagGroupId The ID of the tag group.
 */
const TagGroupActionsMenu: FunctionComponent<IProps> = ({ tagGroup, tagGroupId }) => {
    const { showExploreAction } = useContext(TagsListContext);

    return (
        <div onClick={(event) => event.stopPropagation()}>
            <EllipsisMenu placement="right-center" overflowContainer>
                <DeleteTagGroup tagGroup={tagGroup} tagGroupId={tagGroupId} />
                <EditTagGroup tagGroupId={tagGroupId} />
                {showExploreAction && <ExploreTagGroup tagGroupId={tagGroupId} />}
            </EllipsisMenu>
        </div>
    );
};

export default memo(TagGroupActionsMenu);
